// extracted by mini-css-extract-plugin
export default {"tooltip":"DongTingSDK_tooltip__TWGKD"};